export const StepperDoneIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="32" height="32" rx="16" fill="#728DE3" />
      <path d="M13.2449 19.0597L21.3046 11L22.3747 12.0702L13.2449 21.2L9 16.9564L10.0702 15.8862L13.2449 19.0597Z" fill="white" />
    </svg>
  );
};
